module.exports = __webpack_public_path__ + "static/about-investition6-74e84290410157aac543bce7e9d2c674.jpg";